export default __webpack_public_path__ + "static/media/map-dark-icon.e7603114.svg";